import React, { HTMLAttributes, useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ItensQuantity } from './styles';
import { EOrderSettingsRoutes } from '../../../pages/Purchase/LongSteel/OrderSettingsMvp/orderSettings.routes';
import { ApplicationState } from '../../../store';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import BottomActionBar from '../../BottomActionBar';
import { removeSearchedItem as removeSearchedItemAction } from '../../../store/ducks/long-steel-order-item-search/actions';

export interface ShoppingCartBottomBarProps
  extends HTMLAttributes<HTMLDivElement> {
  onGoToCheckout?: () => Promise<void> | void;
  isContinueDisabled?: boolean;
  showQuantity?: boolean;
  loading?: boolean;
}

export const ShoppingCartBottomBar = (props: ShoppingCartBottomBarProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp?.quantity || 0
  );
  // Componente deve buscar quantidade de itens do carrinho no estado do redux
  const products = cartQuantity;
  const productAmount =
    products > 1 ? 'produtos adicionados' : 'produto adicionado';
  const { emitterId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );
  const { pathname } = useLocation();
  const { commerceScreenName } = getTaggingInformationScreen(pathname);
  const { goBack, push } = useHistory();

  const handleTagging = (buttonLabel: string) => {
    dispatch(
      sendTagging({
        event: 'click',
        screenName: commerceScreenName,
        etapa: 'selecionar_emissor_recebedor',
        botao_navegacao: buttonLabel
      })
    );
  };

  const handleGoBack = () => {
    handleTagging(`voltar`);
    goBack();
  };

  // ! temporário
  const handleGoToCheckout = () => {
    handleTagging(`avancar_para_carrinho`);
    dispatch(removeSearchedItemAction([]));
    push(`./${EOrderSettingsRoutes.SHOPPING_CART}`);
  };

  useEffect(() => {
    const unlisten = history.listen((location: Location, action: string) => {
      if (action === 'POP') {
        dispatch(removeSearchedItemAction([]));
      }
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <BottomActionBar
      previousBtn={{
        fn: handleGoBack,
        name: 'previousBtn',
        text: 'Voltar',
        disabled: props.loading
      }}
      nextBtn={{
        fn:
          typeof props.onGoToCheckout !== 'undefined'
            ? props.onGoToCheckout
            : handleGoToCheckout,
        name: 'nextBtn',
        text: 'Avançar para o carrinho',
        disabled:
          typeof props.isContinueDisabled !== 'undefined'
            ? props.isContinueDisabled
            : !emitterId || products === 0 || props.loading
      }}
    >
      {props.showQuantity !== false && (
        <ItensQuantity>
          {products
            ? `${products} ${productAmount}`
            : 'Nenhum produto adicionado'}
        </ItensQuantity>
      )}
    </BottomActionBar>
  );
};
